import { ControlledTextField } from '@act/storybook';
import { Control } from 'react-hook-form';

export interface TextInputProps {
  control: Control<{ [key: string]: string }>;
  name: string;
  isRequired: boolean;
  isMultiline?: boolean;
}

const TextInput = ({
  control,
  name,
  isRequired,
  isMultiline = false,
}: TextInputProps) => {
  const rows = isMultiline ? 4 : 1;
  return (
    <ControlledTextField
      maxRows={rows}
      name={name}
      label={''}
      control={control}
      required={isRequired}
      multiline={isMultiline}
      minRows={rows}
    />
  );
};

export default TextInput;
